import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserService } from 'app/core/services/user.service';
import { environment } from 'environments/environment';
import { AuthService } from 'app/core/auth/auth.service';
// v4 parent script imported directly so the child (contentWindow) script is
// not bundled into the app — the package root index.js exports both.
import iframeResize from 'iframe-resizer/js/iframeResizer';
import { EventsService } from 'app/core/services/events.service';
import { AutoLogoutService } from 'app/core/services/auto-logout.service';
import { SessionSyncService } from 'app/core/services/session-sync.service';
import { StaffPlanService } from '../../events/pages/staff-plan/staff-plan.service';

@UntilDestroy()
@Component({
    selector: 'app-old-system-iframe',
    templateUrl: './old-system-iframe.component.html',
    styleUrls: ['./old-system-iframe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [CommonModule],
})
export class OldSystemIframeComponent implements AfterViewInit, OnInit {
    iframeLoading: boolean = true;
    internalIframeLoading: boolean = false;
    @Input() src: string;
    @Input() link: string = '';
    @Input() key: string = '';
    iFrameSrc: SafeResourceUrl;

    @ViewChild('myIframe') public myIframe;

    private functionTriggered: boolean = false;
    private _hidden: boolean = true;
    @Input()
    set hidden(value: boolean) {
        this._hidden = value;

        if (!this._hidden && !this.functionTriggered) {
            this.loadIframe();
            this.functionTriggered = true;
        }
    }

    @Output() show: EventEmitter<boolean> = new EventEmitter<boolean>();

    get hidden(): boolean {
        return this._hidden;
    }

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private userService: UserService,
        private _authService: AuthService,
        private _router: Router,
        private events: EventsService,
        private cdr: ChangeDetectorRef,
        private autoLogoutService: AutoLogoutService,
        private staffplanService: StaffPlanService,
        private sessionSyncService: SessionSyncService
    ) {}

    ngOnInit(): void {
        this.events.subscribe('cdr', () => {
            this.cdr.detectChanges();
        });
    }

    async ngAfterViewInit() {
        this.route.queryParams.pipe(untilDestroyed(this)).subscribe(data => {
            if (data.oldSystem) {
                setTimeout(() => {
                    // this.show.emit(true);
                }, 0);
            }
        });
    }

    async loadIframe() {
        let url: string;
        url = `navigator.php?page=pages/${this.src}.php&uid=${this.userService.user.uid}&screen=full`;
        if (this.link != '') {
            url += `&link=${this.link}`;
        }
        if (this.key != '') {
            url += `&key=${this.key}`;
        }

        this.iFrameSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
            environment.apiURL + url
        );
    }

    iFrameLoaded(myIframe) {
        iframeResize(
            {
                checkOrigin: false,
                // heightCalculationMethod: 'lowestElement',
                // widthCalculationMethod: 'scroll',
                // autoResize: true,
                // sizeWidth: true,
                // scrolling:'auto'
            },
            myIframe
        );
        this.injectJavaScript(myIframe);
        this.iframeLoading = false;
    }

    injectJavaScript(myIframe) {
        const iframe = myIframe;
        const iframeWindow = iframe.contentWindow;
        const iframeDocument = iframeWindow.document;

        iframe.contentWindow.onbeforeunload = () => {
            console.log('onbeforeunload');
            this.internalIframeLoading = true;
            this.cdr.detectChanges();
        };

        myIframe.addEventListener('unload', () => {
            console.log('unload');
            this.internalIframeLoading = true;
            this.cdr.detectChanges();
        });

        // Add an event listener to check for URL changes
        myIframe.addEventListener('load', () => {
            console.log('load');
            this.internalIframeLoading = false;
            this.cdr.detectChanges();

            const checkUrl = () => {
                if (
                    iframeWindow.location.href.includes(
                        'navigator.php?page=pages/common/Login.php'
                    )
                ) {
                    this.signOut();
                }
            };

            checkUrl();

            const observer = new MutationObserver(checkUrl);
            observer.observe(iframeDocument.body, {
                childList: true,
                subtree: true,
            });
        });

        // Add styles
        const style = iframeDocument.createElement('style');

        // adding the following class to style.textContent
        // will remove the right scrollbar of the iframe
        // .page-base-right {
        //     margin: 0;
        //     width: 100%;
        //     height: 100%;
        // }

        style.textContent = `
            .page-top, .page-base-left {
                display: none!important;
            }
            .tab_box {
                height: max-content !important;
            }
        `;
        iframeDocument.head.appendChild(style);
    }

    signOut(): void {
        // Logging out inside the old system destroys the shared PHP session,
        // which ends the session in every tab (HIP-40).
        this.sessionSyncService.broadcastLogout();
        this._authService.signOut().subscribe();
        this.autoLogoutService.clearTimer();
        this.staffplanService.resetFilter();
        this._router.navigate(['/sign-in']);
    }

    initializeIframeEventListener(): void {
        window.addEventListener('message', event => {
            if (event.data && event.data.eventType === 'logout') {
                this.signOut();
            } else if (event.data && event.data.eventType === 'loading') {
                this.internalIframeLoading = true;
            } else if (event.data && event.data.eventType === 'loaded') {
                this.internalIframeLoading = false;
            }
        });
    }
}
